export const LOCAL_SCENARIO = 'scenario'
export const LOCAL_GAME_STATE = 'game_state'
export const SUMMARY_HASHID = 'summary_id'
